module.exports = __webpack_public_path__ + "media/brand/customer-app-icon-a67f33e3.svg";